<template>
  <ModalDialog
    ref="dialog"
    id="mydialog"
    @cancel="cancelModal"
    :maxWidth="360"
    :showCancelIcon="true"
    :title="title"
    :posX="posX"
    :posY="posY"
    :dlgStyle="dlgStyle"
    :displayOkButton="true"
    :labelOk="labelOk"
    :labelCancel="labelCancel"
  >
    <div ref="mydialog" class="dlg-choice">
      <form>
        <div class="form-group">
          <div v-if="isOwner" class="nmb-copies mt-2">
            <div class="label text-size-12">
              {{ $t('assignTaskDialog.lblAssign') }}
            </div>
            <select
              @change="onChange($event)"
              class="select-participant text-size-14 selectpicker"
              id="exampleFormControlSelect1"
              data-dropup-auto="false"
              data-size="3"
              data-max-options="2"
            >
              <option v-if="needNoneOption" selected value="none">none</option>

              <option
                v-for="participant in participants"
                :key="participant.id"
                :selected="isSelected(participant)"
                :value="participant.id"
                >{{ participant.name }}</option
              >
            </select>
          </div>
          <div class="task-comment mt-2">
            <InputText
              :label="$t('tasks.comment')"
              :placeholder="$t('options.phDescription')"
              v-model="resource.comment"
              :maxLength="getCommentMaxLength"
            />
            <span class="text-size-10 pt-0 toggle-description">
              {{ getCommentLength }}
            </span>
          </div>
        </div>
      </form>
    </div>

    <template v-slot:buttons>
      <div class="modal-base__footer text-right">
        <BtnLink @click.native="deleteAssigment" :label="labelCancel" />

        <Btn @click.native="updateAssigment" :label="labelOk" />
      </div>
    </template>
  </ModalDialog>
</template>
<script>
import { renderMixin } from '../mixins/RenderMixins';
import { constants } from '@/shared/constant';

const emptyTask = {
  id: null,
  title: '',
  description: '',
  comment: '',
  participant_id: null,
};

export default {
  name: 'ModalAssignTaskDialog',

  data() {
    return {
      posX: 0,
      posY: 0,

      task: emptyTask,
      selectedParticipant_id: 'none',
      invalidTitle: false,
      modalDialog: null,

      resource: { id: null, comment: '', participant_id: null },
    };
  },
  props: ['editMode', 'isMyTask', 'selectedTask', 'selectedResource'],
  watch: {
    selectedTask: function (newVal) {
      if (newVal) {
        this.task = { ...newVal };
      } else {
        this.task = emptyTask;
      }
      this.resource.comment = '';
    },
    selectedResource: function (newVal) {
      console.log('new participant_id:', newVal);
      if (newVal) {
        this.resource.comment = newVal.comment;
        this.resource.id = newVal.id;
      } else {
        this.comment = '';
      }
    },
  },
  mixins: [renderMixin],

  computed: {
    title() {
      const maxLength = 30;

      if (this.task.title.length > maxLength) {
        return this.task.title.substring(0, 30) + '...';
      }
      return this.task.title;
    },

    labelOk() {
      if (this.editMode) {
        return this.$t('assignTaskDialog.btnSave');
      }
      if (this.isOwner) return this.$t('assignTaskDialog.btnAssignJob');
      return this.$t('assignTaskDialog.btnTakeJob');
    },

    labelCancel() {
      if (this.editMode) {
        return this.$t('assignTaskDialog.bntDeleteAssigment');
      }
      return null;
    },

    needNoneOption() {
      if (!this.participant_id) return true;
      return false;
    },

    dlgStyle() {
      const dlgWidth = 360;

      const dlgHeight = 240 + 20;
      const padding = 20;
      console.log('dlgStyle:', this.posY, window.innerHeight);
      if (this.mobileView) {
        let top = this.posY;
        if (top + dlgHeight + padding > window.innerHeight)
          top = window.innerHeight - dlgHeight - padding;

        return 'margin:' + top + 'px auto';
      }

      let left = this.posX;
      if (left + dlgWidth + padding > window.innerWidth)
        left = window.innerWidth - dlgWidth - padding;

      let top = this.posY;
      if (top + dlgHeight + padding > window.innerHeight)
        top = window.innerHeight - dlgHeight - padding;

      const s = ';left:' + left + 'px; top:' + top + 'px';
      return s;
    },
    mobileView() {
      return this.$store.state.mobileView;
    },

    getCommentMaxLength() {
      return constants.commentMaxCharacterLimit;
    },

    getCommentLength() {
      let count = 0;
      if (this.resource.comment) {
        count = this.resource.comment.length;
      }

      return count + ' / ' + this.getCommentMaxLength;
    },
  },

  methods: {
    onChange(e) {
      console.log(e.target.value);
      this.selectedParticipant_id = e.target.value;
    },
    isSelected(participant) {
      if (!this.editMode) return false;
      if (this.selectedResource) {
        return this.selectedResource.participant_id == participant.id;
      }
      return false;
    },

    openModal(event) {
      this.posX = event.clientX;
      this.posY = event.clientY;
      if (this.selectedResource) {
        this.selectedParticipant_id = this.selectedResource.participant_id;
      } else {
        this.selectedParticipant_id = 'none';
      }
      console.log(
        'open dialog selectedParticipant_id: ',
        this.selectedParticipant_id
      );
      this.$refs.dialog.openModal(event);
    },

    cancelModal() {
      this.$emit('cancel');
      this.$refs.dialog.closeModal();
    },

    closeModal() {
      this.$refs.dialog.closeModal();
    },
    updateAssigment() {
      console.log(
        'updateAssigment selectedParticipant_id:',
        this.selectedParticipant_id
      );
      if (this.editMode) {
        if (this.selectedParticipant_id == 'none') return;
        if (this.selectedParticipant_id) {
          this.resource.participant_id = this.selectedParticipant_id;
          this.$emit('update', this.resource);
        }
      } else {
        if (this.selectedParticipant_id == 'none') {
          if (this.isOwner) return;

          const participant = this.participants.find(
            (p) => p.isCurrentUser == true
          );
          if (!participant) {
            console.error(
              'updateAssigment: no participant was found for the auth user'
            );
            return;
          }
          console.log('take job:', participant);
          this.selectedParticipant_id = participant.id;
        }

        this.resource.participant_id = this.selectedParticipant_id;
        this.resource.task_id = this.task.id;
        console.log('onAssign:', this.resource);
        this.$emit('assign', this.resource);
      }
      this.$refs.dialog.closeModal();
    },

    deleteAssigment() {
      this.$emit('unassign', this.resource);
      this.$refs.dialog.closeModal();
    },
  },

  updated() {
    this.modalDialog = this.$refs.dialog;
  },

  mounted() {
    console.error('AssignDialog mounted');
  },
};
</script>
<style scoped lang="scss">
@import '@/styles/style.scss';

input.tasks-cont {
  width: 50px;
}

div.dropdown-menu.open {
  max-height: 314px !important;
  overflow: hidden;
}
ul.dropdown-menu.inner {
  max-height: 260px !important;
  overflow-y: auto;
}

select.select-participant {
  width: 100% !important;
}
</style>
